module.exports = __webpack_public_path__ + "media/images/app/how-it-works/rbtd-icon-mobile-2d184aae1adc72daa8b36bb864758652.webp";